module.exports = __webpack_public_path__ + "static/img/SM.2ec3e07e.png";